import { render, staticRenderFns } from "./OrderRemarkDays.vue?vue&type=template&id=11124786&scoped=true&"
import script from "./OrderRemarkDays.vue?vue&type=script&lang=js&"
export * from "./OrderRemarkDays.vue?vue&type=script&lang=js&"
import style0 from "./OrderRemarkDays.vue?vue&type=style&index=0&id=11124786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11124786",
  null
  
)

export default component.exports